import request from "@/utils/request";


//1,修改专家信息
export function updateJudge(data){
    return request({
        url:'/judge/updateJudge',
        data:data,
        method:'post'
    })
}

//1,获取作品列表
export function getWorks(data){
    return request({
        url:'/judge/getWorks',
        data:data,
        method:'get'
    })
}

//1,获取作品详情
export function getWorkDetail(data){
    return request({
        url:'/judge/getWorkDetail',
        data:data,
        method:'get'
    })
}

//1,打分
export function scoreWork(data){
    return request({
        url:'/judge/scoreWork',
        data:data,
        method:'post'
    })
}

//1,打分
// 需要传入两个参数
// - stage 阶段 1-初赛，2-复赛
// - year 年份
export function getScoreRules(data){
    return request({
        url:'/judge/getScoreRules',
        data:data,
        method:'get'
    })
}

